<template>
  <div class="container admin-table-page">
    <div class="param-title-wrap">
      <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
      </b-button>
      <h2 class="param-title">{{ labels.title }}</h2>
    </div>
    <b-row v-if="!isLoading">
      <div class="admin-table-block mt-4" v-if="listCompany?.length">
        <CorporateDataTable
          :items="companyTableItems"
          :fields="allFields"
          :filter-defs="tableFilterDefs"
          :labels="tableLabels"
          :default-per-page="10"
          :page-options="[10, 20, 50, 100]"
          :narrow="false"
          :table-min-height="500"
          :table-max-height="500"
        >
          <template #toolbar-actions>
            <b-button size="sm" class="table-toolbar-add-btn" @click="goToModalCompany()">
              {{ labels.create }}
            </b-button>
            <b-button size="sm" class="table-toolbar-secondary-btn ml-2" @click="goToModalGrupo()">
              {{ labels.createGroup }}
            </b-button>
            <b-button size="sm" class="table-toolbar-secondary-btn ml-2" @click="goToModalEditGrupo()">
              {{ labels.editGroup }}
            </b-button>
          </template>

          <template #cell(nombre)="data">
            <div class="text-left"><strong>{{ data.item?.nombre }}</strong></div>
          </template>

          <template #cell(acronym)="data">
            <div class="text-center">{{ data.item?.acronym }}</div>
          </template>

          <template #cell(moneda)="data">
            <div class="text-center">{{ data.item?.moneda }}</div>
          </template>

          <template #cell(codigo)="data">
            <div class="text-center">{{ data.item?.codigo }}</div>
          </template>

          <template #cell(grupo)="data">
            <div class="text-center">{{ data.item?.grupo }}</div>
          </template>

          <template #cell(identificacion)="data">
            <div class="text-center">{{ data.item?.identificacion }}</div>
          </template>

          <template #cell(accionEdit)="data">
            <b-button
              style="background-color: #FF924C; width: 30px; height: 30px;"
              class="md-fab md-primary table-action-btn"
              @click.stop="editarCompany(data.item.id)"
            >
              <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
            </b-button>
          </template>

          <template #cell(accionSubsidiary)="data">
            <b-button
              style="background-color: #2e5072; width: 30px; height: 30px;"
              class="md-fab md-primary table-action-btn"
              @click.stop="infoCompany(data.item.id)"
            >
              <i><font-awesome-icon :icon="['fas', 'building']" size="xs"/></i>
            </b-button>
          </template>
        </CorporateDataTable>
      </div>
      <div class="admin-table-block mt-4" v-else>
        <h5>{{ labels.noData }}</h5>
      </div>
    </b-row>
    <b-row v-else>
      <b-col md="12" lg="12" class="p-4 mx-auto">
        <div class="text-center">
          <b-spinner></b-spinner>
        </div>
      </b-col>
    </b-row>

    <!-- Modales -->
    <NewCompany :showDialog="showDialog" @clicked="closeModal" @companyCreated="handleCompanyUpdated"/>
    <Edit :showDialogEdit="showDialogEdit" @clicked="closeModal" :Item="itemSelected" @companyUpdated="handleCompanyUpdated"/>
    <ListSubsidiary
      :showDialogInfo="showDialogInfo"
      @clicked="closeModal"
      :companyName="datosCompany"
    />
    <NewGrupo :showDialogGrupo="showDialogGrupo" @clicked="closeModal" @grupoCreado="recargarGrupos"/>
    <EditGrupo :showDialogEditGrupo="showDialogEditGrupo" @clicked="closeModalEditGrupo" @grupoActualizado="recargarGrupos"/>
  </div>
</template>

<script>
import Company from '@/services/Company'
import Currency from '@/services/Currency'
import Grupo from '@/services/Grupo'
import CorporateDataTable from '../utils/CorporateDataTable.vue'
import NewCompany from '../company/NewCompany.vue'
import Edit from '../company/Edit.vue'
import ListSubsidiary from '../company/ListSubsidiary.vue'
import NewGrupo from '../company/NewGrupo.vue'
import EditGrupo from '../company/EditGrupo.vue'

export default {
  name: "Manage",
  components: {
    NewCompany,
    Edit,
    ListSubsidiary,
    NewGrupo,
    EditGrupo,
    CorporateDataTable
  },
  data: () => ({
    isLoading: false,
    error: false,
    listCompany: [],
    listCurrency: [],
    listGrupos: [],
    showDialog: false,
    showDialogGrupo: false,
    showDialogEditGrupo: false,
    showDialogEdit: false,
    showDialogInfo: false,
    itemSelected: {},
    datosCompany: {},
  }),
  computed: {
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Compañías",
          create: "Crear Compañía",
          edit: "Editar",
          createGroup: "Crear Grupo",
          editGroup: "Editar Grupo",
          name: "Nombre",
          currency: "Moneda",
          acronym: "Acrónimo",
          code: "Código",
          group: "Grupo",
          nit: "NIT",
          subsidiary: "Subsidiarias",
          noData: "No hay compañías registradas",
          noMatches: "No se encontraron resultados",
          searchPlaceholder: "Buscar en la tabla...",
          rowsPerPage: "Filas por página:",
          noSort: "Sin orden",
          sortAsc: "A-Z / Menor a mayor",
          sortDesc: "Z-A / Mayor a menor",
          columns: "Columnas",
          showAllColumns: "Mostrar todas",
          filters: "Filtros",
          clearFilters: "Limpiar filtros",
          filterName: "Filtrar nombre...",
          filterAcronym: "Filtrar acrónimo...",
          filterCode: "Filtrar código...",
          filterNit: "Filtrar NIT..."
        }
      } else {
        return {
          title: "Companies",
          create: "Create Company",
          edit: "Edit Company",
          createGroup: "Create Group",
          editGroup: "Edit Group",
          name: "Name",
          currency: "Currency",
          acronym: "Acronym",
          code: "Code",
          group: "Group",
          nit: "Tax ID",
          subsidiary: "Subsidiaries",
          noData: "No companies registered",
          noMatches: "No results found",
          searchPlaceholder: "Search in table...",
          rowsPerPage: "Rows per page:",
          noSort: "No sorting",
          sortAsc: "A-Z / Low to high",
          sortDesc: "Z-A / High to low",
          columns: "Columns",
          showAllColumns: "Show all",
          filters: "Filters",
          clearFilters: "Clear filters",
          filterName: "Filter name...",
          filterAcronym: "Filter acronym...",
          filterCode: "Filter code...",
          filterNit: "Filter Tax ID..."
        }
      }
    },
    companyTableItems() {
      return (this.listCompany || []).map((item) => ({
        ...item,
        moneda: this.getCurrency(item?.id_moneda),
        grupo: this.getGruposNombres(item?.id_grupos)
      }))
    },
    allFields() {
      return [
        { key: 'nombre', label: this.labels.name, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle' },
        { key: 'acronym', label: this.labels.acronym, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
        { key: 'moneda', label: this.labels.currency, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
        { key: 'codigo', label: this.labels.code, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
        { key: 'grupo', label: this.labels.group, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
        { key: 'identificacion', label: this.labels.nit, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
        { key: 'accionEdit', label: this.labels.edit, thClass: 'text-center', tdClass: 'text-center align-middle', sortable: false },
        { key: 'accionSubsidiary', label: this.labels.subsidiary, thClass: 'text-center', tdClass: 'text-center align-middle', sortable: false }
      ]
    },
    tableFilterDefs() {
      return [
        { key: 'nombre', type: 'text', placeholder: this.labels.filterName },
        { key: 'acronym', type: 'text', placeholder: this.labels.filterAcronym },
        { key: 'codigo', type: 'text', placeholder: this.labels.filterCode },
        { key: 'identificacion', type: 'text', placeholder: this.labels.filterNit }
      ]
    },
    tableLabels() {
      return {
        noRow: this.labels.noData,
        noMatches: this.labels.noMatches,
        searchPlaceholder: this.labels.searchPlaceholder,
        rowsPerPage: this.labels.rowsPerPage,
        noSort: this.labels.noSort,
        sortAsc: this.labels.sortAsc,
        sortDesc: this.labels.sortDesc,
        columns: this.labels.columns,
        showAllColumns: this.labels.showAllColumns,
        filters: this.labels.filters,
        clearFilters: this.labels.clearFilters
      }
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },

    closeModal(value) {
      this.showDialog = value
      this.showDialogGrupo = value
      this.showDialogEdit = value
      this.showDialogInfo = value
      if (!value) {
        this.itemSelected = {}
        this.datosCompany = {}
      }
    },

    closeModalEditGrupo(value) {
      this.showDialogEditGrupo = value
    },

    goToModalCompany() {
      this.showDialog = true
    },

    goToModalGrupo() {
      this.showDialogGrupo = true
    },

    goToModalEditGrupo() {
      if (this.listGrupos.length === 0) {
        this.$toast.warning(this.$store.state._language == "es-ES"
          ? "No hay grupos disponibles para editar"
          : "No groups available to edit")
        return
      }
      this.showDialogEditGrupo = true
    },

    recargarGrupos() {
      this.cargarGrupos()
      this.cargarCompanies()
    },

    async cargarGrupos() {
      try {
        const result = await Grupo.getAllGrupos()
        this.listGrupos = result.data.grupos
      } catch (error) {
        console.error("Error loading grupos:", error)
      }
    },

    editarCompany(id) {
      this.showDialogEdit = true
      Company.getCompanyById(id)
        .then((rta) => {
          this.itemSelected = rta.data.company[0]
        })
        .catch((err) => {
          console.log(err)
          this.$toast.error("Error al cargar la compañía")
        })
    },

    handleCompanyUpdated() {
      this.cargarCompanies()
    },

    cargarCompanies() {
      this.isLoading = true
      Company.getAllCompanies()
        .then((result) => {
          this.listCompany = result.data.companies
        })
        .catch((error) => {
          console.log(error)
          this.error = true
          this.$toast.error("Error al cargar las compañías")
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    infoCompany(id) {
      Company.getCompanyById(id)
        .then((res) => {
          this.datosCompany = res.data.company[0]
          this.showDialogInfo = true
        })
        .catch((err) => {
          console.log(err)
          this.$toast.error("Error al cargar la compañía")
        })
    },

    getGruposNombres(id_grupos) {
      if (!id_grupos) return 'Sin grupo'

      const gruposIds = id_grupos.split(',').map(id => parseInt(id.trim()))
      const gruposNombres = gruposIds.map(id => {
        const grupo = this.listGrupos.find(g => g.id === id)
        return grupo ? grupo?.nombre : 'Grupo desconocido'
      })

      return gruposNombres?.join(', ')
    },

    getCurrency(id) {
      let objMoneda = this.listCurrency.find((obj) => obj.id === id)
      return objMoneda?.nombre || 'N/A'
    }
  },

  mounted() {
    this.isLoading = true

    Promise.all([
      Company.getAllCompanies(),
      Currency.getAllCurrency(),
      Grupo.getAllGrupos()
    ])
    .then(([companiesRes, currencyRes, gruposRes]) => {
      this.listCompany = companiesRes.data.companies
      this.listCurrency = currencyRes.data.currency
      this.listGrupos = gruposRes.data.grupos
    })
    .catch((error) => {
      console.error("Error loading initial data:", error)
      this.error = true
      this.$toast.error("Error al cargar los datos iniciales")
    })
    .finally(() => {
      this.isLoading = false
    })
  }
}
</script>

<style src="../main.css"></style>